import React from 'react'
import { EditorHeading } from '../../ResumeBuilder/Editor/common'
import { EditorItemProvider, EditorItemTextField } from './EditorItemProvider'
import { useCoverLetter } from '../CoverLetterProvider'
import coverLetterMap from './index'
import { useTranslation } from '~/hooks/useTranslation'
import AylaRatingFeedback from '~/components/shared/AylaRatingFeedback'

const ContentEditor = ({ templateIndex }) => {
  const { aylaCoverLetter, documentId, feedbackRating } = useCoverLetter()
  const { coverLetterDocument: { coverLetter } = {} } = useCoverLetter()
  const { t } = useTranslation('Editor.ContentEditor')

  const starDescriptions = t('star_ratings', {
    defaultValue: [
      'Missed the Mark',
      'Needs Improvement',
      'Pretty Good',
      'Really Helpful',
      'Exactly What I Needed',
    ],
  })

  return (
    <div className="flex flex-col">
      <EditorHeading>
        {coverLetterMap[templateIndex]} {t('cover_letter_content')}
      </EditorHeading>
      <p className="pb-4">{t('purpose')}</p>
      {!aylaCoverLetter && (templateIndex == 0 || templateIndex == 1) && (
        <>
          <p className="pb-4">{t('paragraph_one')}</p>
          <p className="pb-4">{t('paragraph_two')}</p>
          <p className="pb-4">{t('paragraph_three')}</p>
        </>
      )}
      {!aylaCoverLetter && templateIndex == 2 && (
        <>
          <p className="pb-4">{t('networking_paragraph_one')}</p>
          <p className="pb-4">{t('networking_paragraph_two')}</p>
          <p className="pb-4">{t('networking_paragraph_three')}</p>
        </>
      )}
      <EditorItemProvider sectionName="coverLetter" item={coverLetter}>
        <EditorItemTextField
          label={t('write_your_cover_letter')}
          containerClassName="md:col-span-2"
          fieldName="content"
          areaClassName="h-[800px]"
        />
      </EditorItemProvider>
      {aylaCoverLetter && (
        <AylaRatingFeedback
          routes={{
            createFeedback: `/personal_brand/cover_letter_builder/${documentId}/feedback`,
          }}
          content={documentId}
          title={t('how_helpful')}
          subtitle={t('your_feedback')}
          starDescriptions={starDescriptions}
          className="mt-12"
          feedbackRating={feedbackRating}
        />
      )}
    </div>
  )
}

export default ContentEditor
